module.exports = __webpack_public_path__ + "img/debian.da1b9b67.svg";